const FieldTypes = {
    'datetime': [4,15,33],
    'date': [31],
    'time': [32],
    'number': [0,5,6,8,9,13,16,17,20],
    'boolean': [1,2],
    'pdf': [400],
    'json': [100],
    'allegato': [201],
    'righe': [98,23]
}

export default FieldTypes;